'use strict';

import React from 'react';

import { useEffect, useState, useRef, useContext } from 'react';

import { Button, Form, Row, Col, Modal } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';
import Select from 'react-select';

import useRequest from '../helper/useRequest';

import { toast } from 'react-toastify';
import useConfirmation from '../helper/Confirmation';
import AppContext from '../AppContext';
import Loader from '../helper/Loader';
import Separator from '../helper/Separator';
import Alert from '../helper/Alert';

import { formatDate, getCurrencyFormatter } from '../helper/DateTimeFormater';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';


import {
    email,
    emailRepeat,
    password,
    passwordRepeat,
    username,
    firstName,
    lastName,
    organisationName,
    phoneNo,
    street,
    houseNo,
    additionToAddress,
    city,
    postCode,
    dataProtection,
    court,
    compRegNo,
    chamberMembership
} from '../helper/Schema';

const schema = yup.object().shape({
    OrganisationName: organisationName,
    Email: email,
    Username: username,
    FirstName: firstName,
    LastName: lastName,
    PhoneNo: phoneNo,
    Street: street,
    HouseNo: houseNo,
    City: city,
    PostCode: postCode,
});

const businessSchema = yup.object().shape({
    OrganisationName: organisationName,
    Email: email,
    Username: username,
    FirstName: firstName,
    LastName: lastName,
    PhoneNo: phoneNo,
    Street: street,
    HouseNo: houseNo,
    City: city,
    PostCode: postCode,
    Radio: yup.string(),
    Court: yup.string().when("Radio", {
        is: (Radio) => Radio === "1",
        then: () => court,
    }),
    CompRegNo: yup.string().when("Radio", {
        is: (Radio) => Radio === "1",
        then: () => compRegNo,
    }),
    ChamberMembership: yup.string().when("Radio", {
        is: (Radio) => Radio === "2",
        then: () => chamberMembership,
    }),
    IsAlternativeBilling: yup.boolean(),
    BillingStreet: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => street,
    }),
    BillingHouseNo: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => houseNo,
    }),
    BillingAdditionToAddress: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => additionToAddress,
    }),
    BillingCity: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => city,
    }),
    BillingPostCode: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => postCode,
    }),
    BillingEmail: yup.string().when("IsAlternativeBilling", {
        is: (IsAlternativeBilling) => IsAlternativeBilling === true,
        then: () => email,
    }),
});

function Registration() {
    const { request } = useRequest();

    const [organisation, setOrganisation] = useState(false);
    const [organisation2, setOrganisation2] = useState(false);
    const [user, setUser] = useState(false);
    const [bookedAbo, setBookedAbo] = useState({});
    const [categories, setCategories] = useState([]);
    const [coupons, setCoupons] = useState([]);
    const [activeCoupons, setActiveCoupons] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let path = location.pathname.split("/");
                if (path.length < 4) return;

                let id = path[3];
                let result = await request("/Operator/GetRegistration", { id: id });
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten.");
                    }
                }
                else {
                    setOrganisation(json.organisation);
                    setUser(json.user);
                    setBookedAbo(json.abo);
                    if (json.categories) {
                        setCategories(json.categories);
                    }

                    if (json.organisation2) {
                        setOrganisation2(json.organisation2);
                    }

                    setCoupons(json.coupons);
                    setActiveCoupons(json.activeCoupons);
                }
            }
            catch (ex) {
                console.error(ex);
                toast.error("Es ist ein Fehler aufgetreten.");
            }
        };
        fetchData();
    }, []);

    if (organisation === false) return <Loader />

    if (user.Role == "School") {
        return <SchoolRegistration user={user} organisation={organisation} organisation2={organisation2} />
    }
    else if (user.Role == "Business") {
        return <BusinessRegistration user={user} bookedAbo={bookedAbo} organisation={organisation} categories={categories} organisation2={organisation2} coupons={coupons} activeCoupons={activeCoupons} />
    }   
}

function SchoolRegistration({ user, organisation, organisation2 }) {
    const { request } = useRequest();
    const confirmation = useConfirmation();

    const { Salutations } = useContext(AppContext);
    const { TypesOfSchool } = useContext(AppContext);
    const [passwordShown, setPasswordShown] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(false);

    const [organisations, setOrganisations] = useState([]);
    const [modal, setModal] = useState(false);

    const formRef = useRef(null);

    const handleSubmitSchool = async (values) => {
        try {
            setLoading(true);
            values.UserID = user.UserID;
            values.OrganisationID = organisation.OrganisationID;
            let result = await request("/Operator/SaveRegistration", values);
            setLoading(false);
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                setDisabled(true);
                toast.success("Die Registrierung wurde gespeichert.");
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    const handleUnlock = async () => {
        try {
            setLoading(true);
            let result = await request("/Operator/UnlockRegistration", { id: user.UserID, organisationID: organisation.OrganisationID });
            setLoading(false);
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Die Registrierung wurde erfolgreich freigegeben.");
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    const handleRefuse = async () => {
        try {
            setLoading(true);
            let result = await request("/Operator/RefuseRegistration", { organisationId: organisation.OrganisationID });
            setLoading(false);
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Die Registrierung wurde erfolgreich abgelehnt.");
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    const loadOrganisations = async () => {
        try {
            setLoading(true);
            let result = await request("/Operator/GetSchools");
            setLoading(false);
            let json = result.data;
            if (json.r == 1) {
                setOrganisations(json.schools);
            }
            else {
                toast.error(json.message);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    useEffect(() => {
        formRef.current.setFieldValue("OrganisationName", organisation.OrganisationName);
        formRef.current.setFieldValue("TypeOfSchoolID", organisation.TypeOfSchoolID);
        formRef.current.setFieldValue("Street", organisation.Street);
        formRef.current.setFieldValue("HouseNo", organisation.HouseNo);
        formRef.current.setFieldValue("AdditionToAddress", organisation.AdditionToAddress);
        formRef.current.setFieldValue("City", organisation.City);
        formRef.current.setFieldValue("PostCode", organisation.PostCode);

        formRef.current.setFieldValue("Email", user.Email);
        formRef.current.setFieldValue("Username", user.Username);

        formRef.current.setFieldValue("SalutationID", user.SalutationID);
        formRef.current.setFieldValue("FirstName", user.FirstName);
        formRef.current.setFieldValue("LastName", user.LastName);

        if (user.Title) formRef.current.setFieldValue("Title", user.Title);
        if (user.PhoneNo) formRef.current.setFieldValue("PhoneNo", user.PhoneNo);

        if (organisation2 != false) {
            setMessage(<><span>Es existiert schon eine Schule mit der gleichen Anschrift. <a href={"/Operator/School/" + organisation2.OrganisationID}>Zur Schule</a></span></>);
        }
        
    }, [user]);

    useEffect(() => {
        loadOrganisations();
    }, []);

    return (
        <>
            {message != false && <Alert type="info" message={message} />}
            <Formik
                innerRef={(f) => formRef.current = f}
                validationSchema={schema}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={(values) => {
                    handleSubmitSchool(values);
                }}
                initialValues={{
                    OrganisationName: '',
                    TypeOfSchoolID: 2,
                    Street: '',
                    HouseNo: '',
                    AdditionToAddress: '',
                    City: '',
                    PostCode: '',
                    Email: '',
                    Username: '',
                    SalutationID: 1,
                    Title: '',
                    FirstName: '',
                    LastName: '',
                    PhoneNo: '',
                    IsSchool: true,
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => (
              
                    <Form noValidate onSubmit={handleSubmit}>
                        <Separator text="Schulinformationen" />
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="OrganisationName">
                                    <Form.Label className="required" column sm={6}>Schulname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.OrganisationName && touched.OrganisationName} placeholder="" name="OrganisationName" value={values.OrganisationName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.OrganisationName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="TypeOfSchoolID" name="TypeOfSchoolID" onBlur={handleBlur} onChange={handleChange}>
                                    <Form.Label className="required" column sm={6}>Schulform</Form.Label>
                                    <Col sm={6}>
                                        <Form.Select disabled={disabled} enabled="true" value={values.TypeOfSchoolID}>
                                            {TypesOfSchool.map((option) => {
                                                return (
                                                    <option key={option.TypeOfSchoolID} value={option.TypeOfSchoolID}>
                                                        {option.Description}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Street">
                                    <Form.Label className="required" column sm={6}>Straße</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.Street && touched.Street} placeholder="" name="Street" value={values.Street} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Street}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="HouseNo">
                                    <Form.Label className="required" column sm={6}>Hausnummer</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.HouseNo && touched.HouseNo} placeholder="" name="HouseNo" value={values.HouseNo} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.HouseNo}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="AdditionToAddress">
                                    <Form.Label column sm={6}>Adresszusatz</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.AdditionToAddress && touched.AdditionToAddress} placeholder="" name="AdditionToAddress" value={values.AdditionToAddress} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.AdditionToAddress}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="PostCode">
                                    <Form.Label className="required" column sm={6}>Postleitzahl</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.PostCode && touched.PostCode} placeholder="" name="PostCode" value={values.PostCode} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.PostCode}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="City">
                                    <Form.Label className="required" column sm={6}>Stadt</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.City && touched.City} placeholder="" name="City" value={values.City} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.City}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Separator text="Benutzerdaten" />
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Email">
                                    <Form.Label className="required" column sm={6}>E-Mail-Adresse</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.Email && touched.Email} placeholder="" name="Email" value={values.Email} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Username">
                                    <Form.Label className="required" column sm={6}>Benutzername</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.Username && touched.Username} placeholder="" name="Username" value={values.Username} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Username}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Separator text="Kontaktdaten" />
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="SalutationID" name="SalutationID" onBlur={handleBlur} onChange={handleChange}>
                                    <Form.Label className="required" column sm={6}>Anrede</Form.Label>
                                    <Col sm={6}>
                                        <Form.Select disabled={disabled} enabled="true" value={values.SalutationID}>
                                            {Salutations.map((option) => {
                                                return (
                                                    <option key={option.SalutationID} value={option.SalutationID}>
                                                        {option.Description}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Title">
                                    <Form.Label column sm={6}>Titel</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.Title && touched.Title} placeholder="" name="Title" value={values.Title} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Title}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="FirstName">
                                    <Form.Label className="required" column sm={6}>Vorname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.FirstName && touched.FirstName} placeholder="" name="FirstName" value={values.FirstName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.FirstName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="LastName">
                                    <Form.Label className="required" column sm={6}>Nachname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.LastName && touched.LastName} placeholder="" name="LastName" value={values.LastName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.LastName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="PhoneNo">
                                    <Form.Label column sm={6}>Telefonnummer</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.PhoneNo && touched.PhoneNo} placeholder="" name="PhoneNo" value={values.PhoneNo} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.PhoneNo}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>

                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={6}>
                                {disabled && <Button disabled={loading} variant="primary" type="button" onClick={() => setDisabled(false)}><i className="fa-solid fa-pen me-2"></i>Bearbeiten</Button>}
                                {!disabled && <Button disabled={loading} variant="secondary" className="me-2" type="button" onClick={() => setDisabled(true)}><i className="fa-solid fa-times me-2"></i>Abbrechen</Button>}
                                {!disabled && <Button disabled={loading} variant="primary" type="submit"><i className="fa-solid fa-check me-2"></i>Speichern</Button>}
                            </Col>
                            <Col xs={12} lg={6} className="text-end">
                                {disabled && <Button disabled={loading} variant="primary" type="button" className="me-2" onClick={() => confirmation.openModal("Bitte Daten überprüfen", "Bitte stellen Sie sicher, dass alle Informationen richtig und plausibel sind.", () => confirmation.openModal("Registrierung freigeben", "Möchten Sie die Registrierung wirklich freigeben?", () => { handleUnlock() }, "Ja", "Nein"), "Fortfahren", "Abbrechen")}><i className="fa-solid fa-check me-2"></i>Freigeben</Button>}
                                {disabled && <Button disabled={loading} variant="secondary" type="button" className="me-2" onClick={() => setModal(true)}><i className="fa-solid fa-object-group me-2"></i>Zusammenführen</Button>}
                                {disabled && <Button disabled={loading} variant="warning" type="button" onClick={() => confirmation.openModal("Registrierung ablehnen", "Möchten Sie die Registrierung wirklich ablehnen?", () => { handleRefuse() }, "Ja", "Nein")}><i className="fa-solid fa-times me-2"></i>Ablehnen</Button>}
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
            <CombineOrganisation modal={modal} setModal={setModal} organisations={organisations} organisationId={organisation.OrganisationID} />
        </>
    );
}

function BusinessRegistration({ user, bookedAbo, organisation, categories, organisation2, coupons, activeCoupons }) {
    const { request } = useRequest();
    const confirmation = useConfirmation();

    const { Salutations } = useContext(AppContext);
    const { TypesOfSchool } = useContext(AppContext);
    const { Categories } = useContext(AppContext);
        
    const [passwordShown, setPasswordShown] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [categorieList, setCategorieList] = useState([]);
    const [message, setMessage] = useState(false);

    const [organisations, setOrganisations] = useState([]);
    const [modal, setModal] = useState(false);

    const formRef = useRef(null);

    const formatter = getCurrencyFormatter();

    const handleSubmit = async (values) => {
        try {
            var data = { ...values };
            data.Category = data.Category.map(item => item.value);
            setLoading(true);
            data.UserID = user.UserID;
            data.OrganisationID = organisation.OrganisationID;
            let result = await request("/Operator/SaveRegistration", data);
            setLoading(false);
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                setDisabled(true);
                toast.success("Die Registrierung wurde gespeichert.");
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    const handleUnlock = async () => {
        try {
            setLoading(true);
            let result = await request("/Operator/UnlockRegistration", { id: user.UserID, organisationId: organisation.OrganisationID });
            setLoading(false);
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Die Registrierung wurde erfolgreich freigegeben.");
                window.location.pathname = "/Operator/Registrations";
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    const handleRefuse = async () => {
        try {
            setLoading(true);
            let result = await request("/Operator/RefuseRegistration", { organisationId: organisation.OrganisationID });
            setLoading(false);
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Die Registrierung wurde erfolgreich abgelehnt.");
                window.location.pathname = "/Operator/Registrations";
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    const loadOrganisations = async () => {
        try {
            setLoading(true);
            let result = await request("/Operator/GetBusinesses");
            setLoading(false);
            let json = result.data;
            if (json.r == 1) {
                setOrganisations(json.businesses);
            }
            else {
                toast.error(json.message);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    useEffect(() => {
        let cats = categories.map(cat => {
            var found = Categories.find(item => item.CategoryID == cat);
            return { label: found.Description, value: found.CategoryID };
        });
        formRef.current.setFieldValue("OrganisationName", organisation.OrganisationName);
        formRef.current.setFieldValue("Category", cats);
       // formRef.current.setFieldValue("TypeOfSchoolID", organisation.TypeOfSchoolID);
        formRef.current.setFieldValue("Street", organisation.Street);
        formRef.current.setFieldValue("HouseNo", organisation.HouseNo);
        formRef.current.setFieldValue("AdditionToAddress", organisation.AdditionToAddress);
        formRef.current.setFieldValue("City", organisation.City);
        formRef.current.setFieldValue("PostCode", organisation.PostCode);
        if (organisation.IsInstitution) {
            formRef.current.setFieldValue("Radio", "4");
        } else if (organisation.Court == null && organisation.ChamberMembership == null) {
            formRef.current.setFieldValue("Radio", "3");
        } else if (organisation.Court == null) {
            formRef.current.setFieldValue("Radio", "2");
            formRef.current.setFieldValue("ChamberMembership", organisation.ChamberMembership);
        } else if (organisation.ChamberMembership == null) {
            formRef.current.setFieldValue("Radio", "1");
            formRef.current.setFieldValue("Court", organisation.Court);
            formRef.current.setFieldValue("CompRegNo", organisation.CompRegNo);
        }
        
        formRef.current.setFieldValue("BillingStreet", organisation.BillingStreet || "");
        formRef.current.setFieldValue("BillingHouseNo", organisation.BillingHouseNo || "");
        formRef.current.setFieldValue("BillingAdditionToAddress", organisation.BillingAdditionToAddress || "");
        formRef.current.setFieldValue("BillingCity", organisation.BillingCity || "");
        formRef.current.setFieldValue("BillingPostCode", organisation.BillingPostCode || "");
        formRef.current.setFieldValue("BillingEmail", organisation.BillingEmail || "");

        if (organisation.BillingEmail != null) {
            formRef.current.setFieldValue("IsAlternativeBilling", true);
        }

        formRef.current.setFieldValue("Email", user.Email);
        formRef.current.setFieldValue("Username", user.Username);

        formRef.current.setFieldValue("SalutationID", user.SalutationID);
        formRef.current.setFieldValue("FirstName", user.FirstName);
        formRef.current.setFieldValue("LastName", user.LastName);

        if (user.Title) formRef.current.setFieldValue("Title", user.Title);
        if (user.PhoneNo) formRef.current.setFieldValue("PhoneNo", user.PhoneNo);

        if (organisation2 != false) {
            setMessage(<><span>Es existiert schon ein Unternehmen mit der gleichen Anschrift. <a href={"/Operator/Business/" + organisation2.OrganisationID}>Zum Unternehmen</a></span></>);
        }


    }, [user]);

    useEffect(() => {
        if (!bookedAbo) return;

        formRef.current.setFieldValue("AboName", bookedAbo.Name);
        formRef.current.setFieldValue("AboPrice", bookedAbo.Price);
        formRef.current.setFieldValue("AboStart", formatDate(bookedAbo.Start));
        formRef.current.setFieldValue("AboEnd", formatDate(bookedAbo.End));
        formRef.current.setFieldValue("AboContingent", bookedAbo.Contingent);
        formRef.current.setFieldValue("AboRadius", bookedAbo.Radius > 300 ? "Deutschlandweit" : bookedAbo.Radius);
        formRef.current.setFieldValue("AboUser", bookedAbo.User > 999 ? "Unbegrenzt" : bookedAbo.User );
        formRef.current.setFieldValue("AboContact", bookedAbo.Contactperson > 999 ? "Unbegrenzt" : bookedAbo.Contactperson);
    }, [bookedAbo]);

    useEffect(() => {
        setCategorieList(Categories.map((ca) => { return { value: ca.CategoryID, label: ca.Description }; }));

        // load all organisations
        loadOrganisations();
    }, []);


    return (
        <>
             {message != false && <Alert type="info" message={message} /> }
            
            <Formik
                innerRef={(f) => formRef.current = f}
                validationSchema={businessSchema}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={(values) => {
                    handleSubmit(values);
                }}
                initialValues={{
                    OrganisationName: '',
                    Category: [],
                    Street: '',
                    HouseNo: '',
                    AdditionToAddress: '',
                    City: '',
                    PostCode: '',
                    Court: '',
                    CompRegNo: '',
                    ChamberMembership: '',
                    Email: '',
                    Username: '',
                    SalutationID: 1,
                    Title: '',
                    FirstName: '',
                    LastName: '',
                    PhoneNo: '',
                    BillingStreet: '',
                    BillingHouseNo: '',
                    BillingAdditionToAddress: '',
                    BillingCity: '',
                    BillingPostCode: '',
                    BillingEmail: '',
                    IsBusiness: true,
                    IsAlternativeBilling: false,
                    Radio: "1",
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => {
                    return (
                        <Form noValidate onSubmit={handleSubmit} className="mt-3">
                            <Separator text="Unternehmensdaten" />
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="OrganisationName">
                                        <Form.Label className="required" column sm={6}>Unternehmensbezeichnung</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.OrganisationName && touched.OrganisationName} placeholder="" name="OrganisationName" value={values.OrganisationName} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.OrganisationName}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="Category">
                                        <Form.Label className="required" column sm={6}>Betriebskategorie</Form.Label>
                                        <Col sm={6}>
                                            <Select isDisabled={disabled} isMulti name="Category" options={categorieList} value={values.Category} classname="basic-multi-select" onChange={
                                                (values) => {
                                                    formRef.current.setFieldValue("Category", values);
                                                }
                                            } />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="Street">
                                        <Form.Label className="required" column sm={6}>Straße</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.Street && touched.Street} placeholder="" name="Street" value={values.Street} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Street}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="HouseNo">
                                        <Form.Label className="required" column sm={6}>Hausnummer</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.HouseNo && touched.HouseNo} placeholder="" name="HouseNo" value={values.HouseNo} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.HouseNo}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AdditionToAddress">
                                        <Form.Label column sm={6}>Adresszusatz</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.AdditionToAddress && touched.AdditionToAddress} placeholder="" name="AdditionToAddress" value={values.AdditionToAddress} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AdditionToAddress}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="PostCode">
                                        <Form.Label className="required" column sm={6}>Postleitzahl</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.PostCode && touched.PostCode} placeholder="" name="PostCode" value={values.PostCode} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.PostCode}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="City">
                                        <Form.Label className="required" column sm={6}>Stadt</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.City && touched.City} placeholder="" name="City" value={values.City} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.City}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="mb-3">
                                <Form.Check
                                    type="radio"
                                    id="radio-1"
                                    name="Radio"
                                    label="Handelsregisternummer & Amtsgericht"
                                    value="1"
                                    checked={values.Radio === "1"}
                                    onChange={handleChange}
                                />
                                <Form.Check
                                    type="radio"
                                    id="radio-2"
                                    name="Radio"
                                    label="Kammerzugehörigkeit"
                                    value="2"
                                    checked={values.Radio === "2"}
                                    onChange={handleChange}
                                />
                                <Form.Check
                                    type="radio"
                                    id="radio-3"
                                    name="Radio"
                                    label="Gewerbeschein"
                                    value="3"
                                    checked={values.Radio === "3"}
                                    onChange={handleChange}
                                />
                                <Form.Check
                                    type="radio"
                                    id="radio-4"
                                    name="Radio"
                                    label="Institution des öffentlichen Rechts"
                                    value="4"
                                    checked={values.Radio === "4"}
                                    onChange={handleChange}
                                />
                            </div>
                            {values.Radio === '1' && (
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="CompRegNo">
                                            <Form.Label className="required" column sm={6}>Handelsregisternummer</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control disabled={disabled} isInvalid={errors.CompRegNo && touched.CompRegNo} placeholder="" name="CompRegNo" value={values.CompRegNo} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.CompRegNo}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="Court">
                                            <Form.Label className="required" column sm={6}>Amtsgericht</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control disabled={disabled} isInvalid={errors.Court && touched.Court} placeholder="" name="Court" value={values.Court} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.Court}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}
                            {values.Radio === '2' && (
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="ChamberMembership">
                                            <Form.Label className="required" column sm={6}>Kammerzugehörigkeit</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control disabled={disabled} isInvalid={errors.ChamberMembership && touched.ChamberMembership} placeholder="" name="ChamberMembership" value={values.ChamberMembership} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.ChamberMembership}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}
                            {values.Radio === '3' && (
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="BusinessLicense">
                                            <Form.Label className="required" column sm={6}>Gewerbeschein</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="IsAlternativeBilling">
                                        <Form.Check disabled={disabled} type="checkbox" label="Abweichende Rechnungsadresse" checked={values.IsAlternativeBilling} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>

                                </Col>
                            </Row>
                            {values.IsAlternativeBilling && (
                                <>
                                    <Separator text="Abweichende Rechnungsadresse" />
                                    <Row>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="BillingEmail">
                                                <Form.Label className="required" column sm={6}>E-Mail-Adresse</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={disabled} isInvalid={errors.BillingEmail && touched.BillingEmail} placeholder="" name="BillingEmail" value={values.BillingEmail} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.BillingEmail}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="BillingStreet">
                                                <Form.Label className="required" column sm={6}>Straße</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={disabled} isInvalid={errors.BillingStreet && touched.BillingStreet} placeholder="" name="BillingStreet" value={values.BillingStreet} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.BillingStreet}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="BillingHouseNo">
                                                <Form.Label className="required" column sm={6}>Hausnummer</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={disabled} isInvalid={errors.BillingHouseNo && touched.BillingHouseNo} placeholder="" name="BillingHouseNo" value={values.BillingHouseNo} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.BillingHouseNo}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="BillingAdditionToAddress">
                                                <Form.Label column sm={6}>Adresszusatz</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={disabled} isInvalid={errors.BillingAdditionToAddress && touched.BillingAdditionToAddress} placeholder="" name="BillingAdditionToAddress" value={values.BillingAdditionToAddress} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.BillingAdditionToAddress}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="BillingPostCode">
                                                <Form.Label className="required" column sm={6}>Postleitzahl</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={disabled} isInvalid={errors.BillingPostCode && touched.BillingPostCode} placeholder="" name="BillingPostCode" value={values.BillingPostCode} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.BillingPostCode}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="BillingCity">
                                                <Form.Label className="required" column sm={6}>Stadt</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={disabled} isInvalid={errors.BillingCity && touched.BillingCity} placeholder="" name="BillingCity" value={values.BillingCity} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.BillingCity}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            <Separator text="Benutzerdaten" />
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="EmailB">
                                        <Form.Label className="required" column sm={6}>E-Mail-Adresse</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.Email && touched.Email} placeholder="" name="Email" value={values.Email} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Email}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="UsernameB">
                                        <Form.Label className="required" column sm={6}>Benutzername</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.Username && touched.Username} placeholder="" name="Username" value={values.Username} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Username}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Separator text="Kontaktdaten" />
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="SalutationID" name="SalutationID" onBlur={handleBlur} onChange={handleChange}>
                                        <Form.Label className="required" column sm={6}>Anrede</Form.Label>
                                        <Col sm={6}>
                                            <Form.Select disabled={disabled} enabled="true" value={values.SalutationID}>
                                                {Salutations.map((option) => {
                                                    return (
                                                        <option key={option.SalutationID} value={option.SalutationID}>
                                                            {option.Description}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="Title">
                                        <Form.Label column sm={6}>Titel</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.Title && touched.Title} placeholder="" name="Title" value={values.Title} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Title}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="FirstName">
                                        <Form.Label className="required" column sm={6}>Vorname</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.FirstName && touched.FirstName} placeholder="" name="FirstName" value={values.FirstName} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.FirstName}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="LastName">
                                        <Form.Label className="required" column sm={6}>Nachname</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.LastName && touched.LastName} placeholder="" name="LastName" value={values.LastName} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.LastName}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="PhoneNo">
                                        <Form.Label column sm={6}>Telefonnummer</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={disabled} isInvalid={errors.PhoneNo && touched.PhoneNo} placeholder="" name="PhoneNo" value={values.PhoneNo} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.PhoneNo}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>

                                </Col>
                            </Row>

                            <Separator text="Abonnement" />
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AboName">
                                        <Form.Label column sm={6}>Paket</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={true} isInvalid={errors.AboName && touched.AboName} placeholder="" name="AboName" value={values.AboName} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AboName}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AboPrice">
                                        <Form.Label column sm={6}>Preis</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={true} isInvalid={errors.AboPrice && touched.AboPrice} placeholder="" name="AboPrice" value={formatter.format(values.AboPrice)} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AboPrice}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {activeCoupons.length > 0 && (
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="CouponReduction">
                                            <Form.Label column sm={6}>Gutschein Rabatt</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control disabled={true} isInvalid={errors.CouponReduction && touched.CouponReduction} placeholder="" name="CouponReduction" value={activeCoupons[0].DiscountPercentage + " %"} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.CouponReduction}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group as={Row} className="mb-3" controlId="AboPriceReducted">
                                            <Form.Label column sm={6}>Reduzierter Preis</Form.Label>
                                            <Col sm={6}>
                                                <Form.Control disabled={true} isInvalid={errors.AboPrice && touched.AboPriceReducted} placeholder="" name="AboPriceReducted" value={formatter.format(values.AboPrice - values.AboPrice * (activeCoupons[0].DiscountPercentage / 100))} onBlur={handleBlur} onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.AboPriceReducted}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            ) }

                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AboStart">
                                        <Form.Label column sm={6}>Start</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={true} isInvalid={errors.AboStart && touched.AboStart} placeholder="" name="AboStart" value={values.AboStart} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AboStart}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AboEnd">
                                        <Form.Label column sm={6}>Ende</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={true} isInvalid={errors.AboEnd && touched.AboEnd} placeholder="" name="AboEnd" value={values.AboEnd} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AboEnd}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AboContingent">
                                        <Form.Label column sm={6}>Kontingent</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={true} isInvalid={errors.AboContingent && touched.AboContingent} placeholder="" name="AboContingent" value={values.AboContingent} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AboContingent}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AboRadius">
                                        <Form.Label column sm={6}>Suchradius</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={true} isInvalid={errors.AboRadius && touched.AboRadius} placeholder="" name="AboRadius" value={values.AboRadius} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AboRadius}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AboUser">
                                        <Form.Label column sm={6}>Benutzer</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={true} isInvalid={errors.AboUser && touched.AboUser} placeholder="" name="AboUser" value={values.AboUser} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AboUser}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="AboContact">
                                        <Form.Label column sm={6}>Kontaktpersonen</Form.Label>
                                        <Col sm={6}>
                                            <Form.Control disabled={true} isInvalid={errors.AboContact && touched.AboContact} placeholder="" name="AboContact" value={values.AboContact} onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.AboContact}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {activeCoupons.length > 0 && (
                                <>
                                    <Separator text="Gutschein" />
                                    <Row>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="CouponCode">
                                                <Form.Label column sm={6}>Code</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={true} isInvalid={errors.CouponCode && touched.CouponCode} placeholder="" name="CouponCode" value={coupons[0].Code} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.CouponCode}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="MaxBookings">
                                                <Form.Label column sm={6}>Maximale Anwendungen</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={true} isInvalid={errors.MaxBookings && touched.MaxBookings} placeholder="" name="MaxBookings" value={coupons[0].MaxBookings} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.MaxBookings}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="Activated">
                                                <Form.Label column sm={6}>Gültig ab</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={true} isInvalid={errors.Activated && touched.Activated} placeholder="" name="Activated" value={formatDate(coupons[0].Activated)} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.Activated}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="Expired">
                                                <Form.Label column sm={6}>Gültig bis</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={true} isInvalid={errors.Expired && touched.Expired} placeholder="" name="Expired" value={formatDate(coupons[0].Expired)} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.Expired}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <Form.Group as={Row} className="mb-3" controlId="Notes">
                                                <Form.Label column sm={6}>Notiz</Form.Label>
                                                <Col sm={6}>
                                                    <Form.Control disabled={true} isInvalid={errors.Notes && touched.Notes} placeholder="" name="Notes" value={coupons[0].Notes} onBlur={handleBlur} onChange={handleChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.Notes}
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                </>
                            )}

                            <Row className="mt-4">
                                <Col xs={12} lg={6}>
                                    {disabled && <Button disabled={loading} variant="primary" type="button" onClick={() => setDisabled(false)}><i className="fa-solid fa-pen me-2"></i>Bearbeiten</Button>}
                                    {!disabled && <Button disabled={loading} variant="secondary" className="me-2" type="button" onClick={() => setDisabled(true)}><i className="fa-solid fa-times me-2"></i>Abbrechen</Button>}
                                    {!disabled && <Button disabled={loading} variant="primary" type="submit"><i className="fa-solid fa-check me-2"></i>Speichern</Button>}
                                </Col>
                                <Col xs={12} lg={6} className="text-end">
                                    {disabled && <Button disabled={loading} variant="primary" type="button" className="me-2"  onClick={() => confirmation.openModal("Bitte Daten überprüfen", "Bitte stellen Sie sicher, dass alle Informationen richtig und plausibel sind.", () => confirmation.openModal("Registrierung freigeben", "Möchten Sie die Registrierung wirklich freigeben?", () => { handleUnlock() }, "Ja", "Nein"), "Fortfahren", "Abbrechen")}><i className="fa-solid fa-check me-2"></i>Freigeben</Button>}
                                    {disabled && <Button disabled={loading} variant="secondary" type="button" className="me-2" onClick={() => setModal(true)}><i className="fa-solid fa-object-group me-2"></i>Zusammenführen</Button>}
                                    {disabled && <Button disabled={loading} variant="warning" type="button" onClick={() => confirmation.openModal("Registrierung ablehnen", "Möchten Sie die Registrierung wirklich ablehnen?", () => { handleRefuse() }, "Ja", "Nein")}><i className="fa-solid fa-times me-2"></i>Ablehnen</Button>}
                                </Col>
                            </Row>

                            <MandatoryFieldNotice />
                        </Form>
                    )
                }}
            </Formik>
            <CombineOrganisation modal={modal} setModal={setModal} organisations={organisations} organisationId={organisation.OrganisationID} />
        </>
    );
}


function CombineOrganisation({ modal, setModal, organisations, organisationId }) {
    const { request } = useRequest();
    const confirmation = useConfirmation();

    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState("");
    const [organisation, setOrganisation] = useState();

    const closeModal = () => {
        setModal(false);
    }

    useEffect(() => {
        if (organisations.length > 0) {
            setOrganisation(organisations[0].OrganisationID);
        }
    }, [organisations]);

    const mergeOrganisation = async () => {
        if (organisation == 0) {
            return toast.error("Bitte eine Organisation zum zusammenführen auswählen.");
        }
        
        try {
            setLoading(true);
            let result = await request("/Operator/MergeOrganisation", { organisationId: organisationId, mergeId: organisation });
            setLoading(false);
            let json = result.data;
            if (json.r == 1) {
                toast.success("Die Registrierung wurde mit dem ausgewählten Unternehmen zusammengeführt.");
                window.location.pathname = "/Operator/Registrations";
            }
            else {
                toast.error(json.message);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
            setLoading(false);
        }
    }

    return (
        <Modal show={modal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Registrierung zusammenführen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message && <Alert type="error" message={message} />}
                <Row>
                    <Col sm={3}>
                        <Form.Label htmlFor="subject">Organisation</Form.Label>
                    </Col>
                    <Col sm={9}>
                        <Form.Select value={organisation} onChange={(e) => {
                            setOrganisation(e.target.value);
                        }}>
                            {organisations.map((orga) => {
                                return (
                                    <option key={orga.OrganisationID} value={orga.OrganisationID}>
                                        {orga.OrganisationName}
                                    </option>
                                );
                            })}
                        </Form.Select>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Abbrechen
                </Button>
                <Button variant="primary" onClick={() => mergeOrganisation()}>
                    Speichern
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default Registration;